export default __webpack_public_path__ + "static/media/EngineeringCanals_07.9b134725.png";